module.exports = __webpack_public_path__ + "static/media/badge_money_1.4373d1af.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_money_1.png
// module id = 493
// module chunks = 0